<template>
  <tci-recruit subtitle="PROJECT MANAGER" :title="$t('recruit.mainPage.recruit_sap')" :recruits="infos"></tci-recruit>
</template>

<script>
import TciRecruit from "@/components/TciRecruit.vue";

export default {
  name: "RecruitServerEngineer",
  components: {
    "tci-recruit": TciRecruit
  },
  data: () => ({
    infos: [{"name":"项目经理", "position":"苏州","email":"suzhou@trans-cosmos.com.cn","requests":[
            "负责业务需求分析、功能设计、项目规划、WBS分解、测试文档的制作；",
            "跟踪项目进度，协调内/外部资源，解决项目推进过程中的课题&问题；",
            "明确团队&成员的任务内容及验收标准, 推进项目如期完成验收；",
            "跟踪控制项目成本，满足客户需求的前提下，完成预定项目目标；",
            "带领团队总结项目经验、知识归档，提升团队成员能力。"
        ],"responses":[
            "本科及以上学历，计算机相关专业；",
            "英语6级相当，能够跟客户交流无障碍、编写英文项目文档资料；",
            "3年以上开发经验，1年以上项目管理经验。",
            "具备较强的客户沟通交流和文档处理能力，良好的团队合作意识和较强的组织协调能力；",
            "有欧美现场工作或外包项目工作经验者优先。"
    ]}
    ]
  })
};
</script>
